<template>
  <div class="mmain">
    <mInfoList fenlei="管理制度"></mInfoList>
  </div>
</template>
<script>
import mInfoList from "@/components/mInfoList.vue";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    
  },
  components: {
    mInfoList
  }
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
}
</style>